import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { TabView, TabPanel } from 'primereact/tabview';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { RouteComponentProps } from "../../models/RouteComponent";
import BillingPricingNew from "./billing-Pricing-New";
import PricingTable from "./components/PricingTable";
import { apiGet } from '../../service/api-service';

interface PricingData {
  id: string;
  usage_type: number;
  cost_system_per_unit: string;
  cost_client_per_unit: string;
  active: boolean;
  effective_date: string;
  created_at: string;
}

export default function BillingPricingView(props: RouteComponentProps) {
  const [visible, setVisible] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<PricingData[]>([]);
  const toast = React.useRef(null as any);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await apiGet('core', 'billing/pricing');
      setData(response.content);
    } catch (error) {
      console.error('Error fetching pricing data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const getFilteredData = () => {
    const now = new Date();
    switch(activeIndex) {
      case 0: // Upcoming
        return data.filter(row => new Date(row.effective_date) > now);
      case 1: // Active
        return data.filter(row => row.active);
      case 2: // Expired
        return data.filter(row => !row.active && new Date(row.effective_date) < now);
      default:
        return data;
    }
  };

  return (
    <React.Fragment>
      <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
        <TabPanel header="Upcoming">
          <PricingTable
            data={getFilteredData()}
            loading={loading}
            onNewClick={() => setVisible(true)}
            onRefresh={fetchData}
            showDelete={true}
          />
        </TabPanel>
        <TabPanel header="Active">
          <PricingTable
            data={getFilteredData()}
            loading={loading}
            onNewClick={() => setVisible(true)}
            onRefresh={fetchData}
            showDelete={false}
          />
        </TabPanel>
        <TabPanel header="Expired">
          <PricingTable
            data={getFilteredData()}
            loading={loading}
            onNewClick={() => setVisible(true)}
            onRefresh={fetchData}
            showDelete={false}
          />
        </TabPanel>
      </TabView>

      <Dialog
        header="New Client Cost"
        visible={visible}
        style={{ width: '50vw' }}
        onHide={() => setVisible(false)}
      >
        <BillingPricingNew
          setGlobalLoading={props.setGlobalLoader}
          setReload={fetchData}
          setVisible={setVisible}
          toast={toast}
        />
      </Dialog>

      <Toast ref={toast} />
    </React.Fragment>
  );
}
